import React from 'react';

const InsuranceYes = () => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 62 60"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path id="a" d="M.638.84H34.61v33.97H.64z" />
      <circle id="c" cx="17.624" cy="17.825" r="13.986" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M52.936 38.284c4.35-12.695-.433-26.656-11.295-33.646l.89-1.54c.36-.618.13-1.47-.486-1.824-.616-.356-1.467-.128-1.823.488l-.89 1.54C27.46-2.83 12.426-.104 3.77 9.9c-.6.68-.857 1.662-.552 2.558.163.607.57 1.15 1.186 1.506.23.133.385.222.66.28.276.055.63.156.982.257.75.128 1.808.43 2.27.697 3.237 1.87 5.33 4.825 5.648 8.193.073.76.545 1.546 1.315 1.99.77.446 1.686.46 2.382.144 2.743-1.19 5.766-1.09 8.72.204l-6.586 11.405c-.916-.015-1.823.49-2.313 1.336-1.735 3.004-5.503 4.013-8.508 2.28-1.54-.89-2.682-2.475-3.016-4.21-.27-1.49-1.69-2.412-3.103-2.1-1.492.27-2.414 1.69-2.1 3.105.636 3.347 2.698 6.182 5.627 7.872 5.548 3.204 12.598 1.315 15.8-4.234.49-.847.473-1.885.002-2.67L28.77 27.11c2.6 1.91 4.198 4.476 4.538 7.447-.003.717.468 1.503 1.24 1.948.77.445 1.685.46 2.382.143 3.03-1.333 6.68-1.074 9.84.75.155.09.484.587.747.842.374.42.747.842 1.12 1.263.155.09.264.256.418.345.617.356 1.367.48 2.02.24.894-.304 1.57-.94 1.86-1.8v-.004zm-43.283-25.4C8.573 12.26 6.875 12 5.74 11.652 13.54 2.592 27.114.258 37.72 5.56c-2.254.342-6.95 1.535-12.19 5.805-5.15 4.116-7.95 8.253-9.15 10.334-.856-3.68-3.182-6.77-6.727-8.82v.004zm19.265 11.122c-3.545-2.047-7.46-2.56-10.998-1.418 1.113-1.926 3.823-5.91 8.808-9.915 5.45-4.457 10.365-5.318 12.01-5.498.667 1.515 2.3 6.157 1.167 13.105-1.01 6.2-3.104 10.538-4.14 12.51-.9-3.603-3.303-6.737-6.847-8.784zM48.182 35.13c-3.544-2.048-7.46-2.562-10.997-1.42 1.2-2.08 3.385-6.573 4.374-13.09 1.075-6.674-.24-11.337-1.07-13.46 9.817 6.49 13.723 19.122 9.943 30.296-.605-.554-1.482-1.883-2.253-2.327h.002z"
        fill="#D0CDD0"
      />
      <circle
        cx="14.624"
        cy="14.825"
        r="13.986"
        transform="translate(33 31)"
        fill="#58CC81"
      />
      <g transform="translate(30 28)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <circle
          cx="14.624"
          cy="14.825"
          r="13.986"
          transform="translate(3 3)"
          mask="url(#b)"
        />
      </g>
      <path
        stroke="#FFF"
        strokeWidth="3"
        d="M41.042 46.805l4.35 4.348 9.44-9.442"
      />
    </g>
  </svg>
);
export default InsuranceYes;
